import { Core } from "@/core/Core";

export default {

  /* Categories */

  async getBrandings(context, {inventoryId}) {
    try {
      return await Core.request("GET", "/api/inventory/" + inventoryId + "/brandings");
    } catch (e) {
      return null;
    }
  },

  async getBranding(context, {inventoryId, brandingId}) {
    try {
      return await Core.request("GET", "/api/inventory/" + inventoryId + "/brandings/" + brandingId);
    } catch (e) {
      return null;
    }
  },

  async saveBranding(context, {inventoryId, brandingId, data}) {
    try {
      return await Core.request("PUT", "/api/inventory/" + inventoryId + "/brandings/" + brandingId, data);
    } catch (e) {
      return null;
    }
  },

  async createBranding(context, {inventoryId, data}) {
    try {
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/brandings", data);
    } catch (e) {
      return null;
    }
  },

  async deleteBranding(context, {inventoryId, brandingId}) {
    try {
      return await Core.request("DELETE", "/api/inventory/" + inventoryId + "/brandings/" + brandingId);
    } catch (e) {
      return null;
    }
  }

}
